<form [formGroup]="formGroup" class="tax-form">

    <ng-container>

        <!-- PrimeNG Table -->
        <div [formArrayName]="tableKey" class="card rounded-lg bg-[#fafbfc] overflow-x-auto">
            <p-table [value]="getVisibleTableRows()" [tableStyle]="{'min-width':'100%'}" [size]="'small'">

                <!-- Header -->
                <ng-template pTemplate="header">
                    <tr>
                        <!-- Selection Checkbox Column - First (if enabled) -->
                        <th *ngIf="showSelectionCheckbox && !viewMode" class="text-sm text-center" style="width: 60px; min-width: 60px;">
                            <div class="checkbox-single dynamic-checkbox">
                                <input type="checkbox" 
                                [checked]="isAllSelected()"
                                [indeterminate]="isIndeterminate()"
                                (change)="toggleSelectAll($event)"
                                [id]="'selectAll_' + tableKey"
                                class="checkbox-single w-full min-w-full" />
                            </div>
                        </th>
                        <!-- Serial Number Column -->
                        <th *ngIf="showSerialNumber" class="text-sm text-center" style="width: 80px; min-width: 80px;">
                            S.No
                        </th>
                        <ng-container *ngFor="let col of dynamicFormFields">
                            <th *ngIf="!shouldHideField || !shouldHideField(col)"
                                [class.text-right]="isNumericField(col)"
                                class="text-sm"
                                [style.width]="getColumnWidth(col)"
                                [style.min-width]="getColumnMinWidth(col)">
                                {{ col.display_name || col.field_name }}
                                <span *ngIf="col.is_mandatory" class="text-red-500 ml-1">*</span>
                            </th>
                        </ng-container>
                        <!-- Custom action column header (if provided) -->
                        <th *ngIf="customActionColumn" class="custom-action-column" style="width: 100px; min-width: 100px; position: sticky; right: 80px; background-color: #fafbfc; z-index: 10;">
                            Actions
                        </th>
                        <!-- Add button column - always at the end -->
                        <th *ngIf="!viewMode && showAddRemoveButtons" class="add-button-column" style="width: 80px; min-width: 80px; position: sticky; right: 0; background-color: #fafbfc; z-index: 10;">
                            <!-- Add Row button -->
                            <p-button icon="pi pi-plus-circle" [rounded]="true" [outlined]="true" [text]="true"
                                (click)="addTableRow()">
                            </p-button>
                        </th>
                    </tr>
                </ng-template>

                <!-- Body -->
                <ng-template pTemplate="body" let-rowData>
                    <tr [formGroup]="rowData.control">
                        <!-- Selection Checkbox Column - First (if enabled) -->
                        <td *ngIf="showSelectionCheckbox && !viewMode">
                            <div class="checkbox-single dynamic-checkbox">
                                <input  type="checkbox" class="checkbox-single" 
                                [formControlName]="'_selected'"
                                (change)="onSelectionChange(rowData.index, $event)" />
                            </div>
                        </td>
                        <!-- Serial Number Column -->
                        <td *ngIf="showSerialNumber" class="text-sm text-center">
                            {{ rowData.index + 1 }}
                        </td>
                        <ng-container *ngFor="let col of dynamicFormFields">
                            <td *ngIf="!shouldHideField || !shouldHideField(col)"
                                [class.text-right]="isNumericField(col)"
                                [style.width]="getColumnWidth(col)"
                                [style.min-width]="getColumnMinWidth(col)">

                            <ng-container [ngSwitch]="col.field_type">
                                <!-- Redirect field renders as link in both modes -->
                                <a *ngSwitchCase="'redirect'"
                                   class="text-sm text-primary underline cursor-pointer"
                                   [routerLink]="getRedirectCommands(col)"
                                   [queryParams]="getRedirectQueryParams(col, rowData.control)">
                                    {{ getTableCellDisplayValue(col, rowData.control, rowData.index) }}
                                </a>

                                <!-- Label / read-only fields -->
                                <span *ngSwitchCase="'label'" class="text-sm">
                                    {{ getTableCellDisplayValue(col, rowData.control, rowData.index) }}
                                </span>

                                <!-- Tag field - shows "primary" text only on first visible row -->
                                <ng-container *ngSwitchCase="'tag'">
                                    <p-tag 
                                        *ngIf="isFirstVisibleRow(rowData.index)"
                                        value="primary"
                                        styleClass="p-tag-primary">
                                    </p-tag>
                                </ng-container>

                                <!-- File upload field -->
                                <ng-container *ngSwitchCase="'file_upload'">
                                    <!-- View mode: Show file name with download link -->
                                    <div *ngIf="viewMode" class="file-view-container">
                                        <ng-container *ngIf="hasFileValue(rowData.index, col.field_name)">
                                            <a class="text-sm text-primary underline cursor-pointer"
                                               (click)="openDownloadUrl(rowData.index, col.field_name); $event.preventDefault()">
                                                {{ getSelectedFileName(col, rowData.index) }}
                                            </a>
                                        </ng-container>
                                        <span *ngIf="!hasFileValue(rowData.index, col.field_name)" class="text-sm text-gray-400">-</span>
                                    </div>
                                    <!-- Edit mode: File upload control -->
                                    <div *ngIf="!viewMode" class="file-upload-container">
                                        <input
                                            type="file"
                                            class="file-input"
                                            [id]="getTableFieldKey(rowData.index, col.field_name)"
                                            [accept]="col.accept || '*'"
                                            [multiple]="col.multiple || false"
                                            (change)="onFileSelected($event, col, rowData.index)"
                                            #tableFileInput
                                        />
                                        <!-- Show Choose File button only when no file is selected -->
                                        <label *ngIf="!getSelectedFileName(col, rowData.index)" [for]="getTableFieldKey(rowData.index, col.field_name)" class="file-upload-btn">
                                            <i class="pi pi-upload"></i>
                                            <span>{{ col.upload_label || 'Choose File' }}</span>
                                        </label>
                                        <!-- Show file name with download link when file is selected -->
                                        <ng-container *ngIf="getSelectedFileName(col, rowData.index)">
                                            <a class="text-sm text-primary underline cursor-pointer"
                                               (click)="openDownloadUrl(rowData.index, col.field_name); $event.preventDefault()">
                                                {{ getSelectedFileName(col, rowData.index) }}
                                            </a>
                                        </ng-container>
                                    </div>
                                </ng-container>

                                <!-- Default rendering -->
                                <ng-container *ngSwitchDefault>
                                    <!-- View mode fallback -->
                                    <span *ngIf="viewMode" class="text-sm">
                                        {{ getTableCellDisplayValue(col, rowData.control, rowData.index) }}
                                    </span>

                                    <!-- Non-editable fields: Show as read-only display value -->
                                    <span *ngIf="!viewMode && isNonEditableField(col)" class="text-sm">
                                        {{ getTableCellDisplayValue(col, rowData.control, rowData.index) }}
                                    </span>

                                    <!-- EDIT MODE: Input controls -->
                                    <ng-container *ngIf="!viewMode && !isNonEditableField(col)">

                                <!-- Text input -->
                                <input *ngIf="col.field_type === 'input' || !col.field_type" pInputText
                                    class="p-inputtext-sm w-full" [formControlName]="getFieldKey(col.field_name)"
                                    [placeholder]="col.display_name" (input)="onTableFieldChange(rowData.index, col.field_name, $event)" />

                                <!-- Number input -->
                                <input *ngIf="col.field_type === 'number'" type="number" pInputText
                                    class="p-inputtext-sm w-full" [formControlName]="getFieldKey(col.field_name)"
                                    [placeholder]="col.display_name" (input)="onTableFieldChange(rowData.index, col.field_name, $event)" />

                                <!-- Select dropdown -->
                                 
                                <p-select *ngIf="col.field_type === 'select'" [options]="getFieldOptions(rowData.index, col)"
                                    optionLabel="label" optionValue="value"
                                    appendTo="body"
                                    [formControlName]="getFieldKey(col.field_name)"
                                    [placeholder]="'Select ' + col.display_name" size="small" fluid class="w-full"
                                    [showClear]="true"
                                    (onChange)="onTableFieldChange(rowData.index, col.field_name, $event)">
                                </p-select>

                                <!-- Date picker -->
                                <p-datepicker *ngIf="col.field_type === 'date'"
                                    appendTo="body"
                                    [formControlName]="getFieldKey(col.field_name)" dateFormat="dd/mm/yy"
                                    [showIcon]="true" [appendTo]="'body'" [showIcon]="false" [timeOnly]="false" [showTime]="false"
                                    class="w-full" size="small" (onSelect)="onTableFieldChange(rowData.index, col.field_name, $event)">
                                </p-datepicker>

                                <!-- Time picker -->
                                <p-datepicker *ngIf="col.field_type === 'datetime'"
                                    appendTo="body"
                                    [formControlName]="getFieldKey(col.field_name)" [timeOnly]="true"
                                    [hourFormat]="'24'" [showIcon]="false" [appendTo]="'body'" class="w-full"
                                    size="small" (onSelect)="onTableFieldChange(rowData.index, col.field_name, $event)">
                                </p-datepicker>

                                <!-- Checkbox -->
                                <div *ngIf="col.field_type === 'checkbox'" class="checkbox-single dynamic-checkbox">
                                    <input  type="checkbox" class="checkbox-single" 
                                    [formControlName]="getFieldKey(col.field_name)"
                                    (change)="onTableFieldChange(rowData.index, col.field_name, $event)" />
                                </div>

                                <!-- Radio button (without options only) -->
                                <div class="flex small-radio-group items-center gap-2" *ngIf="col.field_type === 'radio'">
                                    <input
                                        type="radio"
                                        class="radio-single small-radio"
                                        [name]="getFieldKey(col.field_name)"
                                        size="small"
                                        [formControlName]="getFieldKey(col.field_name)"
                                        [id]="getFieldKey(col.field_name) + '_' + rowData.index"
                                        [value]="getRadioButtonValue(col)"
                                        [checked]="isRadioRowSelected(rowData.index, col.field_name)"
                                        (change)="onTableFieldChange(rowData.index, col.field_name, $event)"
                                    />
                                </div>

                                <!-- Textarea -->
                                <textarea *ngIf="col.field_type === 'textarea'" rows="2" class="p-inputtextarea w-full"
                                    [formControlName]="getFieldKey(col.field_name)" [placeholder]="col.display_name"
                                    (input)="onTableFieldChange(rowData.index, col.field_name, $event)"></textarea>

                                <!-- Search with Autocomplete -->
                                <p-autocomplete *ngIf="col.field_type === 'autocomplete' || col.field_type === 'search'"
                                    fluid
                                    size="small"
                                    appendTo="body"
                                    [formControlName]="getFieldKey(col.field_name)"
                                    [placeholder]="'Search ' + col.display_name"
                                    [suggestions]="getSearchSuggestions(rowData.index, col)"
                                    [optionLabel]="col.optionLabel || col.autocompleteDisplayField || 'label'"
                                    [dropdown]="true"
                                    [optionValue]="col.optionValue || 'value'"
                                    [forceSelection]="col.forceSelection !== false"
                                    (completeMethod)="onSearchQuery($event, rowData.index, col)"
                                    (onSelect)="onSearchSelect($event, rowData.index, col.field_name)"
                                    class="filter-autocomplete">
                                </p-autocomplete>

                                <!-- Regex validation error (small red line) -->
                                <div
                                  *ngIf="regexValidationErrors && regexValidationErrors[getRowFieldKey(rowData.index, col.field_name)]"
                                  class="mt-0 pt-0 text-[11px] leading-snug text-red-500"
                                >
                                  {{ regexValidationErrors[getRowFieldKey(rowData.index, col.field_name)] }}
                                </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            </td>
                        </ng-container>

                        <!-- Custom action column (if provided) -->
                        <td *ngIf="customActionColumn" class="text-center custom-action-column" style="width: 100px; min-width: 100px; position: sticky; right: 80px; background-color: #fafbfc; z-index: 10;">
                            <ng-container *ngIf="getCustomActionConfig(rowData.index, rowData.control) as actionConfig">
                                <p-button 
                                    *ngIf="actionConfig.show"
                                    [label]="actionConfig.svgIcon ? undefined : (actionConfig.label || 'Action')"
                                    [text]="actionConfig.svgIcon ? true : false"
                                    [rounded]="actionConfig.svgIcon ? true : false"
                                    size="small"
                                    severity="secondary"
                                    (onClick)="handleCustomActionClick($event, actionConfig)"
                                    [disabled]="actionConfig.disabled || false">
                                    <ng-container *ngIf="actionConfig.svgIcon">
                                        <span class="svg-icon-wrapper" [innerHTML]="getSanitizedSvg(actionConfig.svgIcon)" (click)="$event.stopPropagation()"></span>
                                    </ng-container>
                                </p-button>
                            </ng-container>
                        </td>

                        <!-- Delete button (only in edit mode) - always at the end -->
                        <td class="text-center remove-button-column" *ngIf="!viewMode && showAddRemoveButtons && !(shouldHideDeleteButton && shouldHideDeleteButton(rowData.control))" style="width: 80px; min-width: 80px; position: sticky; right: 0; background-color: #fafbfc; z-index: 10;">
                            <p-button icon="pi pi-times" [rounded]="true"
                                [outlined]="true" [text]="true" (click)="removeTableRow(rowData.index)">
                            </p-button>
                        </td>
                    </tr>
                </ng-template>

                <!-- Totals Row -->
                <ng-template pTemplate="footer" *ngIf="shouldShowTotalsRow()">
                    <tr class="totals-row">
                        <!-- Selection Checkbox Column - Empty cell -->
                        <td *ngIf="showSelectionCheckbox && !viewMode" class="text-sm text-center" style="width: 60px; min-width: 60px;">
                        </td>
                        <!-- Serial Number Column - Empty cell -->
                        <td *ngIf="showSerialNumber" class="text-sm text-center" style="width: 80px; min-width: 80px;">
                        </td>
                        <ng-container *ngFor="let col of dynamicFormFields; let first = first">
                            <td *ngIf="!shouldHideField || !shouldHideField(col)"
                                class="text-sm font-semibold"
                                [class.text-right]="shouldShowTotalForField(col)"
                                [class.text-left]="!shouldShowTotalForField(col) && first"
                                [style.width]="getColumnWidth(col)"
                                [style.min-width]="getColumnMinWidth(col)">
                                <!-- Show "Total" label in first column -->
                                <span *ngIf="first && !shouldShowTotalForField(col)" class="text-gray-900">
                                    Total
                                </span>
                                <!-- Show total value for numeric fields -->
                                <span *ngIf="shouldShowTotalForField(col)" class="text-gray-900">
                                    {{ calculateTotal(col.field_name) | number:'1.2-2' }}
                                </span>
                                <!-- Empty cell for non-total fields (except first) -->
                                <span *ngIf="!first && !shouldShowTotalForField(col)"></span>
                            </td>
                        </ng-container>
                        <!-- Add button column - Empty cell -->
                        <td *ngIf="!viewMode && showAddRemoveButtons" class="add-button-column" style="width: 80px; min-width: 80px; position: sticky; right: 0; background-color: #fafbfc; z-index: 10;">
                        </td>
                    </tr>
                </ng-template>

            </p-table>
        </div>

        <div class="flex justify-start gap-2 mt-4" *ngIf="!viewMode && showBulkActionButtons">
            <p-button label="Clear All Lines" (onClick)="deleteAllRows()" styleClass="bulk-action-btn" />
            <p-button label="Duplicate Line" (onClick)="duplicateLastRow()" styleClass="bulk-action-btn" />
        </div>

    </ng-container>
</form>